import classNames from "classnames"
import styles from './styles.module.less'
import { CheckOutlined, CloseOutlined, MoreOutlined } from "@ant-design/icons"
import { Button, Dropdown, Input, InputRef, Space } from "antd"
import { SimSeq, SimulationModal, deleteSimSeq, updateSimSeq } from "@/services/project/simulation.service"
import { useRef, useState } from "react"

const seqItems = [
  {
    label: 'Rename',
    key: 'rename',
  },
  {
    label: 'Delete',
    key: 'delete',
  },
]

interface SeqActionRowProps {
  seq: SimSeq
  active: boolean
  onSelect: (seq: SimSeq) => void
  sim: SimulationModal
  refresh: () => void
}
export const SeqActionRow = (props: SeqActionRowProps) => {
  const {seq, active = false, onSelect, sim, refresh} = props
  const [edit, setEdit] = useState(false)
  const inputRef = useRef<InputRef>(null)
  const [name, setName] = useState(seq.name)

  const onSave = async () => {
    await updateSimSeq({sequence: {...seq, name}}, {sId: sim.id, id: seq.index})
    setEdit(false)
    refresh()
  }

  const onDeleted = async () => {
    await deleteSimSeq({sId: sim.id, id: seq.index})
    refresh()
  }

  return <div
    className={
    classNames(
      'flex-space-btw',
      styles.actionItem,
      active && styles.active
    )}
    onClick={() => {
      onSelect(seq)
    }}>
  <div>
    {!edit && <div>{seq.name}</div>}
    {edit && <Space style={{padding: '5px'}}>
      <Input style={{flex: 1}} ref={inputRef} value={name} onChange={(e) => {
        setName(e.target.value)
      }} />
      <Space>
        <Button icon={<CheckOutlined />} style={{color: 'green'}} onClick={onSave} />
        <Button icon={<CloseOutlined />} style={{color: 'red'}} onClick={() => setEdit(false)}/>
      </Space>
    </Space>}
  </div>
  <Dropdown menu={{ items: seqItems, onClick: (action) => {
    if (action.key === 'rename') {
      setEdit(true)
    } else if (action.key === 'delete') {
      onDeleted()
    }
  } }}><MoreOutlined /></Dropdown>
  </div>
}